module.exports = __webpack_public_path__ + "img/icon-check-circle.78eee40c.svg";